import { useEffect, useState } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebounce = (value: any, delay = 500) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [debouncedValue, setDebouncedValue] = useState<any>(value)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => clearTimeout(timeout)
  }, [value, delay])

  return debouncedValue
}
